import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { routerNavigatedAction } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { filter, tap } from 'rxjs';

import { StateService } from '@ninety/platform/services/services/state.service';

import { appActions } from './app.actions';
import { selectCurrentRoute } from './route.selectors';

@Injectable()
export class AppEffects {
  private readonly actions$ = inject(Actions);
  private readonly stateService = inject(StateService);
  private readonly store = inject(Store);

  stateServiceInit$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(appActions.initStateService),
        tap(() => this.stateService.init())
      ),
    { dispatch: false }
  );

  routeChange$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(routerNavigatedAction),
        concatLatestFrom(() => this.store.select(selectCurrentRoute)),
        filter(([, route]) => route?.outlet === 'primary'),
        tap(([, route]) => this.stateService.onRouteChange(route.data))
      ),
    { dispatch: false }
  );
}
